import { IotizeConfigModel } from './model/iotize-config-model';

/**
 * Utility class to create iotize config model from XML or JSON file
 */
export class IotizeConfigFactory {
  /**
   * Create IotizeConfigModel from a XML string
   * @param xml
   */
  static fromXML(xml: string): IotizeConfigModel {
    throw new Error(
      `Add import to @iotize/tap/config/iotize-studio/parser/xml to create configuration model from XML file`,
    );
  }

  /**
   * Create IotizeConfigModel from a JSON string
   * @param json
   */
  static fromJson(json: string) {
    return new IotizeConfigModel(JSON.parse(json));
  }

  /**
   * Build and IotizeConfigModel
   * Input can either be
   * - A json string
   * - A XML string
   * - A JSON Object
   *
   * TODO create test
   * @param data
   */
  static create(data: string | Object): IotizeConfigModel {
    if (typeof data === 'string') {
      data.trim();
      if (data.length === 0) {
        throw new Error('Cannot create configuration from empty data');
      }
      if (data[0] === '{') {
        return IotizeConfigFactory.fromJson(data);
      } else {
        return IotizeConfigFactory.fromXML(data);
      }
    } else {
      return new IotizeConfigModel(data);
    }
  }
}
